<script setup>
import { useI18n } from '../../i18n'
defineProps({ assignees: { type: Array, default: () => [] } })
const { t } = useI18n()
</script>
<template><aside class="role-assignees"><h2>{{ t('usersWithRole') }} <span>{{ assignees.length }}</span></h2><ul v-if="assignees.length"><li v-for="user in assignees" :key="user.id"><span class="access-avatar">{{ (user.displayName || user.username).slice(0, 2).toUpperCase() }}</span><span><strong>{{ user.displayName }}</strong><small>{{ user.username }}</small></span></li></ul><p v-else class="muted">{{ t('roleUnassigned') }}</p></aside></template>
